/**
 * 消息设置
 */
import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 提醒类型枚举
 */
class ReminderType extends UltMeta {
    CONTRACT_EXPIRATION = new Meta(1, "合同到期提醒");
    ACCOUNT_EXPIRATION = new Meta(2, "账期到期提醒");
}

export const REMINDER_TYPE = new ReminderType();

/**
 * 提醒次数
 */
class RemindTimes extends UltMeta {
    ONE = new Meta(1, "提醒一次");
    TWO = new Meta(2, "提醒二次");
}

export const REMINDER_TIMES = new RemindTimes();

/**
 * 提醒时间类型
 */
class RemindTimeType extends UltMeta {
    THREE_DAY = new Meta(1, "提前3天", 3);
    SEVEN_DAY = new Meta(2, "提前7天", 7);
    HALF_MONTH = new Meta(3, "提前15天", 15);
    CUSTOMIZE = new Meta(4, "自定义", 0);
}

export const REMIND_TIME_TYPE = new RemindTimeType();

/**
 * 提醒方式
 */
class RemindWay extends UltMeta {
    SMS = new Meta(1, "短信");
    INTERNAL_MESSAGE = new Meta(2, "站内消息");
    ALL = new Meta(3, "短信；站内消息");
}

export const REMINDER_WAY = new RemindWay();
